import React from "react";
import styles from "./tradingPlacesFilter.module.scss";
import { Check } from "@frui.ts/bootstrap";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { observer } from "mobx-react-lite";

type Props = {
  vm: TradingPlacesViewModel;
};
const TradingPlacesFilter = observer(({ vm }: Props) => {
  return (
    <div className={styles.checkboxGroup}>
      <div className={styles.checkbox}>
        <Check autoComplete="off" custom target={vm} property="allTradingPlacesVisible" label={vm.translate("filterAll")} />
      </div>
      <div className={styles.checkbox}>
        <Check autoComplete="off" custom target={vm.visibleTradingPlaces} property="kiosk" label={vm.translate("filterKiosks")} />
      </div>
      <div className={styles.checkbox}>
        <Check
          autoComplete="off"
          custom
          target={vm.visibleTradingPlaces}
          property="salesPoint"
          label={vm.translate("filterSalesPoints")}
        />
      </div>
    </div>
  );
});

export default TradingPlacesFilter;
